import { Pressable } from 'react-native';
import React, { useRef, useCallback } from 'react';
import { toast } from 'sonner';

// Using semantic HTML elements instead of Text component
import { GitHubStarsButton } from './github-stars-button';
import { updateSpiralAngle } from '@/components/animated-spiral/spiral-mutable-angle';
import { Environment } from '@/env';
import { cn } from '@/utils/cn';

// Hero text gradient - subtle light gradient
const GRADIENT_ROW =
  'bg-clip-text text-transparent bg-gradient-to-r from-[#ffffffd9] via-[#ffffff] to-[#ffffffd9] font-medium';

const TITLE_STYLES = {
  transform: 'translateZ(20px)',
};

const DESCRIPTION_STYLES = {
  transform: 'translateZ(10px)',
};

const TITLE_CLASSNAME = cn(
  GRADIENT_ROW,
  'font-poppins-medium transition-all duration-150 ease-out group-hover:opacity-80 group-hover:scale-[1.02] text-[2.5rem] sm:text-[5rem] md:text-[7rem] lg:text-[9rem]'
);

const DESCRIPTION_CLASSNAME = cn(
  GRADIENT_ROW,
  'font-poppins-medium text-left sm:text-center text-sm sm:text-base md:text-lg max-w-xs sm:max-w-md md:max-w-lg'
);

const TOAST_CONFIG = {
  duration: 10000,
  position: 'bottom-center',
  icon: '✨',
  action: {
    label: 'Check tutorial',
    onClick: () => {
      return window.open(
        `${Environment.WEBSITE_URL}/articles/animated-spiral`,
        '_blank'
      );
    },
  },
} as const;

export const LandingHero = () => {
  const tapCount = useRef(0);

  const handlePress = useCallback(() => {
    updateSpiralAngle();
    tapCount.current += 1;

    if (tapCount.current === 7) {
      toast.message("Seems that you're loving this animation", TOAST_CONFIG);
    }
  }, []);

  return (
    <header className="flex w-full items-start sm:items-center perspective-1000 flex-col overflow-visible">
      <div className="fade-in-down-1">
        <Pressable
          className="mb-2 sm:mb-6 md:my-8 cursor-pointer group"
          onPress={handlePress}
          accessibilityRole="button"
          accessibilityLabel="Tap to animate spiral background"
        >
          <h1 className={TITLE_CLASSNAME} style={TITLE_STYLES}>
            Demos
          </h1>
        </Pressable>
      </div>

      <div className="fade-in-down-2">
        <div className={DESCRIPTION_CLASSNAME} style={DESCRIPTION_STYLES}>
          110+ React Native animations
          <br className="hidden sm:block" />
          <span className="sm:hidden"> </span>
          with Skia, Reanimated and Gesture Handler
        </div>
      </div>

      {/* Open Source Announcement */}
      <div className="fade-in-down-3 mt-4 sm:mt-6 overflow-visible">
        <GitHubStarsButton />
      </div>
    </header>
  );
};
